import { change } from 'redux-form';
import { CHARGE_PERMISSION_FORM_NAME } from 'Common/FormEnum';
import { FieldEnum } from 'Common/FieldEnum';

export const updateChargePermissions = (
  newSiteId,
  prevSiteId,
  isNewStudent
) => {
  return (dispatch, getState) => {
    const sites = getState().CommonState.sites.info.Data;
    const newSite = sites.filter(s => s.Id === newSiteId)[0];

    if (isNewStudent) {
      changeChargeFlag(newSite, dispatch);
      changeAlaCarte(newSite, dispatch);
    } else {
      //existing student, determine if they were set to charge defaults at their previous site
      //and if so, update them to the new site's defaults
      const oldSite = sites.filter(s => s.Id === prevSiteId)[0];
      const student = getState().form[CHARGE_PERMISSION_FORM_NAME].values;

      if (student[FieldEnum.ChargeFlag] === oldSite.ChargeFlag) {
        changeChargeFlag(newSite, dispatch);
      }

      const sameAlaCarteExpense =
        (student[FieldEnum.AlaCarteExpense] ? 'Y' : 'N') ===
        oldSite.AlaCarteExpense;

      if (sameAlaCarteExpense) {
        //Always update if Student = Old Site = 'N'
        //Mostly to handle MP9 data that has:
        //   AlaCarteExpense = 'N' and a non-null AlaCarteExpFrequency
        if (!student[FieldEnum.AlaCarteExpense]) {
          changeAlaCarte(newSite, dispatch);
        } else {
          //If Student = Site = 'Y', only update when Student = Site
          //for Frequency and Amount too
          const sameAlaCarteExpFrequency =
            (student[FieldEnum.AlaCarteExpFrequency]
              ? student[FieldEnum.AlaCarteExpFrequency]
              : '') === oldSite.AlaCarteExpFrequency;

          const sameAlaCarteExpAmount =
            student[FieldEnum.AlaCarteAmount] === oldSite.AlaCarteExpAmount;

          if (sameAlaCarteExpFrequency && sameAlaCarteExpAmount) {
            changeAlaCarte(newSite, dispatch);
          }
        }
      }
    }
  };
};

const changeChargeFlag = (site, dispatch) => {
  dispatch(
    change(CHARGE_PERMISSION_FORM_NAME, FieldEnum.ChargeFlag, site.ChargeFlag)
  );
};

const changeAlaCarte = (site, dispatch) => {
  dispatch(
    change(
      CHARGE_PERMISSION_FORM_NAME,
      FieldEnum.AlaCarteExpense,
      site.AlaCarteExpense === 'Y'
    )
  );
  dispatch(
    change(
      CHARGE_PERMISSION_FORM_NAME,
      FieldEnum.AlaCarteAmount,
      site.AlaCarteExpAmount
    )
  );
  dispatch(
    change(
      CHARGE_PERMISSION_FORM_NAME,
      FieldEnum.AlaCarteExpFrequency,
      site.AlaCarteExpFrequency
    )
  );
};



// WEBPACK FOOTER //
// ./src/pages/accountsetup/state/chargeDefaults/actions.js